import type { SpotImage } from './firebaseService';

/**
 * Brukerdelte bilder skal ALLTID vinne i visningen. Sorterer bruker-bilder
 * først (source undefined = eldre brukeropplastninger, eller 'user'), deretter
 * auto-hentede kilder (google/wikimedia/mapillary). Innad i hver gruppe bevares
 * innkommende rekkefølge (kalleren leverer uploaded_at desc), så nyeste bilde
 * vises først. V8s Array.sort er stabil, så kun gruppe-rang sammenlignes.
 *
 * Rein funksjon uten Firebase-avhengigheter → enhetstestbar isolert.
 * `import type` over erases ved kompilering, så ingen runtime-import av firebase.
 */
export const sortSpotImagesUserFirst = (images: SpotImage[]): SpotImage[] => {
  const rank = (img: SpotImage) => (!img.source || img.source === 'user') ? 0 : 1;
  return [...images].sort((a, b) => rank(a) - rank(b));
};
